import React, { useCallback, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageCarouselProps {
  images: string[];
}
export function ImageCarousel({
  images
}: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  }, [images.length]);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  }, [images.length]);
  return <div className="relative w-full max-w-lg mx-auto" data-id="element-169">
      <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl shadow-lg bg-white" data-id="element-170">
        <AnimatePresence mode="wait" data-id="element-171">
          <motion.img key={currentIndex} src={images[currentIndex]} alt={`Product view ${currentIndex + 1}`} className="h-full w-full object-cover" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-172" />
        </AnimatePresence>

        {/* Navigation Arrows */}
        <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 text-gray-800 shadow-sm hover:bg-white transition-colors" aria-label="Previous image" data-id="element-173">
          <ChevronLeft className="h-5 w-5" data-id="element-174" />
        </button>
        <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-white/80 p-2 text-gray-800 shadow-sm hover:bg-white transition-colors" aria-label="Next image" data-id="element-175">
          <ChevronRight className="h-5 w-5" data-id="element-176" />
        </button>
      </div>

      {/* Thumbnails */}
      <div className="mt-4 flex justify-center gap-3" data-id="element-177">
        {images.map((img, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`relative h-16 w-16 overflow-hidden rounded-lg border-2 transition-all ${currentIndex === index ? 'border-[#C06B6B] ring-2 ring-[#C06B6B]/20' : 'border-transparent opacity-70 hover:opacity-100'}`} data-id="element-178">
            <img src={img} alt={`Thumbnail ${index + 1}`} className="h-full w-full object-cover" loading="lazy" data-id="element-179" />
          </button>)}
      </div>
    </div>;
}